import { useDispatch, useSelector } from 'react-redux';
import { getPackages, addPayment, assignPackageToStudent, updatePackage, clearPackages, assignBulkPackage, deletePackage } from '../store/slices/packagesSlice';

export const usePackages = () => {
    const dispatch = useDispatch();
    const { packages, loading, error } = useSelector((state) => state.packages);

    const fetchPackages = (studentId) => {
        if (studentId) {
            dispatch(getPackages({ studentId }));
        }
    };

    const addPaymentToPackage = (paymentData) => {
        return dispatch(addPayment(paymentData));
    };

    const assignPackageToStudentAction = (assignData) => {
        return dispatch(assignPackageToStudent(assignData));
    };

    const updatePackageAction = (updateData) => {
        return dispatch(updatePackage(updateData));
    };

    const assignBulkPackageAction = (bulkData) => {
        return dispatch(assignBulkPackage(bulkData));
    };

    const deletePackageAction = (id) => {
        return dispatch(deletePackage(id));
    };

    const clearPackagesList = () => {
        dispatch(clearPackages());
    };

    return {
        packages,
        loading,
        error,
        fetchPackages,
        addPaymentToPackage,
        assignPackageToStudentAction,
        updatePackageAction,
        assignBulkPackageAction,
        clearPackagesList,
        deletePackageAction
    };
}; 